exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-details li{display:flex;list-style:none;align-items:center;line-height:16px;margin-bottom:5px}.product-details li span{display:inline-block}.product-details svg{fill:currentColor;width:15px;height:15px}.product-details .icon{margin-right:1rem;display:inline-flex}.product-details .icon>span{display:inline-flex}.product-details--highlighted{color:var(--dark-green)}.product-details--highlighted .icon{margin-right:.5rem}.product-details--highlighted li{line-height:16px!important;margin-bottom:12px}.product-details .old-price{color:var(--gray-300);font-style:italic;text-decoration:line-through}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/greenmotion-shared/Components/quotes/scss/product-details-simplified.scss
// module id = Wuze
// module chunks = 22